import TopTitle from "../components/TopTitle";
import InscriptionImage from "../assets/img/inscripcion.jpg";
import { getInscriptionPeriod } from "../utils/date";

function Inscription() {
  const inscription = getInscriptionPeriod();

  return (
    <div className="main-content">
      <TopTitle title="Inscripción de alumnos regulares" />
      <section className="bg-light">
        <div className="container">
          <div className="row align-items-center justify-content-center py-2">
            {inscription.admision && !inscription.regular &&(
              <h2 className="pb-sm-3 pb-md-5">¡Las inscripciones de alumnos regulares
                para el periodo académico {inscription.label} aún no comienzan!
              </h2>
            )}
            {inscription.endedInscriptions && (
              <h2 className="pb-sm-3 pb-md-5">¡Las inscripciones para el periodo académico {inscription.label} han finalizado!</h2>
            )}
            <div className="col-md-6">
              <img src={InscriptionImage} alt="Inscripción" className="img-fluid" />
            </div>
            <div className="col-md-6">
              <h4 className="pt-sm-3 pt-md-0">Proceso de inscripción</h4>
              <p className="py-2">
                Para realizar el proceso de inscripción debe entrar a la página de
                <a className="text-primary px-1" href="https://iuta.terna.net/" target="_blank" rel="noopener noreferrer">TernaNet</a>
                y seguir los siguientes pasos:
              </p>
              <ul className="lists lists-2" role="tablist">
                <li>Ingresar con el usuario y contraseña creado por el estudiante y Pulsar entrar.</li>
                <li>Ir al menú ubicado a la izquierda seleccione: <span className="text-bold">Estudiante - Inscripción.</span></li>
                <li>En el menú horizontal, seleccionar el Período Académico: {inscription.label}.</li>
                <li>En la tabla de Asignaturas Cursables, seleccione las materias a cursar y la sección:</li>
              </ul>
              <ul className="lists lists-1 pb-2 ps-4" role="tablist">
                <li>Modalidad presencial: la sección es 1-PLC, BNA, PTP (según la sede a la que pertenece).</li>
                <li>Modalidad sabatina: 1S-PLC, BNA, PTP (según la sede a la que pertenece).</li>
                <li>Modalidad virtual: 1V-PLC.</li>
              </ul>
            </div>
            <div className="pt-4 pb-2">
              Nota importante:
              <ul className="lists lists-3 py-2" role="tablist">
                <li>Las materias que aparecen en color verde, son las materias que puedes inscribir.</li>
                <li>Si quieres eliminar alguna de las materias puedes hacer clic en la columna Acción de la tabla de Solicitud de Inscripción.</li>
              </ul>
            </div>
          </div>
          <div>
            <h4>Proceso de pago</h4>
            <p className="py-2">
              Despues de realizar el proceso de inscripción, el estudiante debe realizar el pago de la tasa de inscripción a través de los siguientes pasos:
            </p>
            <ul className="lists lists-2 pb-2" role="tablist">
              <li>En el menú principal, seleccione Cuenta Virtual - Tipo Movimiento: Depósito/Transferencia/ Pago Móvil Banesco y Plaza</li>
              <li>Registre los datos de su planilla de pago.</li>
              <li>Debe cancelar dependiendo si es alumno regular o de reingreso.</li>
            </ul>
            <h5 className="pt-4 pb-2">
              *Al momento de finalizar la inscripción de las asignaturas debe realizar el pago, recuerde que la tasa cambia diariamente.
            </h5>
            <h5 className="pb-2">
              *Cuando registre el monto de la transferencia, si requiere colocar decimales utilice el punto, no coloque coma para separación de miles.
            </h5>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Inscription;
